module.exports = __webpack_public_path__ + "img/07_shimizu_25.38439df2.jpg";